import { Injectable } from '@angular/core';
import { catchError, tap, map, finalize } from 'rxjs/operators';
import {
  HttpInterceptor, HttpRequest,
  HttpHandler, HttpEvent, HttpErrorResponse, HttpHeaders
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

//import { Toastr, ToastrManager } from 'ng6-toastr-notifications';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from '../global.service';
import { LocalService } from './local.service';
@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  //errorFlag:string="EF";
  // spinnerFlag:string ="SF"
  constructor(toastr: ToastrService, private spinner: NgxSpinnerService, private global: GlobalService, private local: LocalService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    if (!String(req.url).includes("/signin") && !String(req.url).includes("/adminupload")
      && !String(req.url).includes("/getDMSUpload")
      && !String(req.url).includes("/getDmsClaimNotification")
      && !String(req.url).includes("/getDmsEndorsementsUpload")
      && !String(req.url).includes("/getFleetUpload")
      && !String(req.url).includes("/adminImgUpload")
      && !String(req.url).includes("/quoteRequestUpload")
      && !String(req.url).includes("mcdmsupload")
      && !String(req.url).includes("mcdmsview") && !String(req.url).includes("mcdmsdelete")
      && !String(req.url).includes("meddmsupload")
      && !String(req.url).includes("meddmsview") && !String(req.url).includes("meddmsdelete")
      && !String(req.url).includes("medreqdmsupload")
    ) {

      let newReq = req.clone({

        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept-Language': this.global.selectLang,
          'Authorization': "Bearer " + this.local.getString("token")
        })
      })

      return next.handle(newReq).pipe(map(event => {
        this.global.showProgress.emit(true)
        return event;
      }), catchError(error => {
        this.global.showProgress.emit(false)
        return this.errorHandler(error);
      }), finalize(() => {
        this.global.showProgress.emit(false)
      }))
    }
    else if (String(req.url).includes("/adminupload")
      || String(req.url).includes("/adminupload")
      || String(req.url).includes("/getDMSUpload")
      || String(req.url).includes("/getDmsClaimNotification")
      || String(req.url).includes("/getDmsEndorsementsUpload")
      || String(req.url).includes("/getDmsEndorsementsUpload")
      || String(req.url).includes("/getFleetUpload")
      || String(req.url).includes("/adminImgUpload")
      || String(req.url).includes("/quoteRequestUpload")
      || String(req.url).includes("/mcdmsupload")
      || String(req.url).includes("/meddmsupload")
      || String(req.url).includes("/medreqdmsupload")) {
      let newReq = req.clone({
        headers: new HttpHeaders({
          'enctype': 'multipart/form-data',
          // 'Authorization': "Bearer " + this.local.getString("token")
          // 'lang': this.global.selectLang
        })
      })
      return next.handle(newReq).pipe(map(event => {
        //this.global.showProgress.emit(true)
        return event;
      }), catchError(error => {
        // this.global.headerAction = "";
        //this.global.showProgress.emit(false)
        return this.errorHandler(error);
      }), finalize(() => {
        // this.global.headerAction = "";
        //this.global.showProgress.emit(false)
      }))
    }
    const newReq2 = req.clone({
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept-Language': this.global.selectLang,
        //'lang': this.global.selectLang,
       // 'Authorization': "Bearer " + this.local.getString("token")
      })
    })

    return next.handle(newReq2).pipe(map(event => {
      if (!String(req.url).includes("assets/i18n/")) {
        this.global.showProgress.emit(true);
      }

      return event;
    }), catchError(error => {
      if (!String(req.url).includes("assets/i18n/")) {
        this.global.showProgress.emit(false);
      }
      return this.errorHandler(error);
    }), finalize(() => {

      this.global.showProgress.emit(false)
    }))
  }
  errorHandler(error: HttpErrorResponse) {
    this.global.showProgress.emit(false)
    this.global.messageEmitter.emit(error.error.responseBody.errorMessage)
    return throwError(error);
  }
}